import useDocument, { DocumentConfig } from './useDocument';
import { PurchaseOrder, PurchaseOrderStatus } from '../models/purchaseOrder';

const config: DocumentConfig = {
  listKey: 'purchaseOrders',
  detailKey: 'purchaseOrder',
  basePath: 'purchaseOrder',
  archivePath: (id) => `purchaseOrder/${id}/Archive`,
  // EPIC_VOID_FLOW_2026-10 (item 1571) — POs get a void (archive needs a dead PO now)
  voidPath: (id) => `purchaseOrder/${id}/Void`,
  voidType: 'PurchaseOrder',
  statusPath: (id) => `purchaseOrder/${id}/SetStatus`,
  statusAsJson: true,
};

const usePurchaseOrder = (props: { id?: string }) => {
  const doc = useDocument<PurchaseOrderStatus, PurchaseOrder>(config, props);
  return { ...doc, trySetStatus: doc.tryStatus };
};

export default usePurchaseOrder;
